import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";
import Title from "../component/title";
import WelfareBudget from "./component/welfare-budget";
import Portrait from "./component/portrait";
import "./scss/budget.scss";
import ChinaCityMap from "./component/china-city-map";
import MapTopRanking from "./component/map-top-ranking";
import { isEmpty } from "lodash";
import Empty from "@/component/empty";
import moWelfare from "./store/wealfare";
import WelfareProject from "./component/welfare-project";
import WelfarePortrait from "./component/welfare-portrait";
import KeyHoliday from "./component/key-holiday";
import dayjs from "dayjs";
import moIndex from "../store";

interface IProps {}
interface IState {}

const Budget = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { WelfareCityRankDate } = moWelfare;
  const { isMock } = moIndex;
  const now = new Date(); // 当前日期
  const nowMonth = now.getMonth(); // 当前月
  const nowYear = now.getFullYear(); // 当前年
  // 本月的开始时间
  const monthStartDate = new Date(nowYear, nowMonth, 1);
  const remonthStartDate = dayjs(monthStartDate).format("YYYY-MM");

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section className="budget-page-warp">
      <section className="tops-title-warp" id="budget">
        <Title title="福利洞察" subtitle="企业预算" />
        <p>
          预算说明：企业福利预算是指除法定福利外，企业用于提供给员工的各项弹性福利的经费。包括：生日节假日的礼包礼券、员工体检、企业活动、弹性福利平台等。不包括：企业年金、商业保险。
        </p>
      </section>
      {/* <span className="update-time">
        统计周期：最近12个月，更新时间：2021-12
      </span> */}
      <section className="budget-top-pic">
        <WelfareBudget />
        <Portrait />
      </section>
      <section className="budget-city-warp">
        <span className="sub-title">人均福利城市排行榜</span>
        {!isEmpty(WelfareCityRankDate) ? (
          <section className="budget-pic-group">
            <ChinaCityMap />
            <MapTopRanking />
            {isMock && (
              <img
                src="https://file.smartsalary.cn/web-img%402.0/market/image/ismock.png"
                alt=""
              />
            )}
          </section>
        ) : (
          <Empty margin="20px 0 0" />
        )}
      </section>
      <section className="budget-warp-project">
        <WelfareProject />
      </section>
      <section className="budget-warp-protrait">
        <WelfarePortrait />
      </section>
      <section className="budget-warp-holiday">
        <KeyHoliday />
      </section>
    </section>
  );
};

export default observer(Budget);
